export default __webpack_public_path__ + "static/media/square1.8c4d1fda.png";